<!--
 * @Desc: 创建问题
 * @Author: hedahai
 * @Date: 2020-10-26 10:56:59
-->
<template>
  <div class="create-question">
    <el-dialog title="默认问题单模板"
               :visible.sync="show"
               width="980px"
               @close="close"
               :close-on-click-modal='false'
               center>
      <div>
        <el-checkbox :indeterminate="isIndeterminate"
                     v-model="checkAll"
                     @change="handleCheckAllChange"
                     style="margin-left:50px">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="checkedQuestions"
                           @change="handleCheckedQuestionChange"
                           style="margin-left:50px">
          <el-checkbox v-for="(question,index) in questionList"
                       :label="question"
                       :key="question.id"
                       style="width:100%; height:50px" :checked="checkedArr[index]"  @change="checked=>singleBoxChange(checked, index)">
                      <el-input :disabled="!checkedArr[index]" v-model="question.addText" style="width:300px;margin-right:20px;"></el-input>
                      <el-input :disabled="true" v-model="question.questionContent" style="width:300px;"></el-input>
                      <el-input :disabled="!checkedArr[index]" v-model="question.sort" style="width:60px;margin-left:20px;" placeholder="序号"></el-input>
          </el-checkbox>
        </el-checkbox-group>
        <div class="custom-questions">
          <div class="custom-question"
               v-for="(item, index) in customQuestionList"
               :key="index">
            <img class="icon" src="@/assets/casespace/question_icon.png" />
            <el-input class="input"
                      v-model="item.text"
                      placeholder="请输入内容" maxlength='400'></el-input>
            <el-input  v-model="item.sort" style="width:60px;margin-left:10px;margin-right:10px;" placeholder="序号"></el-input>
            <i class="el-icon-delete icon"
               style="color:#1e6dcb"
               @click="deleteCustomQuestion(index)"></i>
          </div>
          <el-button type="text"
                     style="margin-top:5px"
                     icon="el-icon-plus"
                     @click="addCustomQuestion" v-if="!isClosed">新增问题</el-button>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary"
                   @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getDefalutQuestionListApi, submitQuestionsApi } from '@/api/question_list.js'
import quesListVue from '../components/quesList.vue'
export default {
  data() {
    return {
      show: true,
      questionList: [],
      checkAll: false,
      checkedQuestions: [],
      checkedArr:[],
      isIndeterminate: true,
      customQuestionList: [{ text: '' }],
      isClosed: localStorage.getItem('CloseState') =='true' ? true : false,
      submitflag: false,
    }
  },
  created() {
    console.log('新建问题组件初始化',this.$router.query)
    this.getData()
  },
  methods: {
    // 关闭事件
    close() {
      this.$emit("closeEvent")
    },
    // 获取数据
    getData() {
      if (this.questionList.length) return
      getDefalutQuestionListApi().then(res => {
        console.log(res.data.data)
        this.questionList = res.data.data
        let checkedArr = []
        this.questionList.map(item => {
           checkedArr.push(false)
        })
        this.checkedArr = checkedArr
        console.log('----questionList-----',this.questionList)
      }).catch(err => {
        console.log(err)
      })
    },
    handleCheckAllChange(val) {
      console.log(val)
      this.checkedQuestions = val ? this.questionList : []
      this.isIndeterminate = false

      for(let i=0;i<this.checkedArr.length;i++){
         this.checkedArr[i] = val
      }
      // this.checkedArr.forEach(item => {
      //   item = val
      // })
      console.log('--jjj--',this.checkedArr)
    },
    handleCheckedQuestionChange(value) {
      console.log(value)
      console.log('zenyang----',this.checkedArr)
      let checkedCount = value.length
      this.checkAll = checkedCount === this.questionList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.questionList.length
    },
    singleBoxChange(value,index){
       console.log('single----',value,index)
       this.checkedArr[index] = value
    },
    // 添加默认问题
    addCustomQuestion() {
      this.customQuestionList.push({ text: '' })
    },
    // 删除默认问题
    deleteCustomQuestion(index) {
      this.customQuestionList.splice(index, 1)
    },
    // 提交按钮的点击事件
    submit() {
      console.log(this.checkedQuestions)
      console.log(this.customQuestionList)
      let questionList = []
      // 拼接模板问题
      this.checkedQuestions.map(item => {
        questionList.push({
          questionType: item.questionType,
          questionContent: (item.addText ? item.addText : '') + item.questionContent,
          sort:item.sort
        })
      })
      console.log(questionList)
      // 拼接普通问题
      this.customQuestionList.map(item => {
        if (item.text.length) {
          questionList.push({
            questionType: 0,
            questionContent: item.text,
            sort:item.sort
          })
        }
      })
      //校验问题内容是否有特殊符号 &
      const hasChar = questionList.find(item => {
          return item.questionContent.indexOf('&') != -1 || item.questionContent.indexOf('$') != -1 || item.questionContent.indexOf('#') != -1
      }) 
      if(hasChar){
        this.$message.warning('问题包含特殊符号')
        return
      } 
      const emptySort = questionList.find(item => {
          return  !item.sort
      })
      if(emptySort){
        this.$message.warning('问题序号为空')
        return
      }
      let rule = /^[1-9]\d*$/
      const numSort = questionList.find(item => {
         return !rule.test(item.sort)
      })
     if(numSort){
       this.$message.warning('序号只能是数字')
       return
     }
      let params = {
        mediationId: this.$route.query.meetingid,
        questionList: questionList
      }
      if (!questionList.length) {
        this.$message.warning('您还没有选择问题')
        return
      }
      if (this.submitflag) return
      this.submitflag = true
      submitQuestionsApi(params).then(res => {
         console.log(res)
         this.submitflag = false
        if(res.data.code === 1000){
          this.show = false
          console.log('chuangjian ')
          this.$message.success('创建成功')
          this.$emit('createQuestionEvent')
        }else{ 
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 取消按钮的点击事件1
    cancel() {
      this.show = false
    }
  },
}
</script>

<style lang="scss">
.create-question {
  .el-button {
    border-radius: 4px;
    // margin-right: 10px;
  }
  .custom-questions {
    background: #f6f7f9;
    border-radius: 4px;
    margin: 0 50px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .custom-question {
      // margin-top: 20px;
      height: 50px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .icon {
        font-size: 24px;
      }
      .input {
        width: 480px;
        // height: 32px;
        margin: 0 10px;
      }
    }
  }
}
</style>